import { getProductId, getProductLineId } from './../../order-builder/modules/specification/helpers/product.helper';
import { IProduct } from '@cemex-core/cmx-api/models/product/models/product.interface';
import { Injectable } from '@angular/core';
import { CustomerPaymentTermsReq, PaymentTermService, OrderTypeCodesEnum } from '@cemex-core/cmx-api';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map, switchMap, take, filter } from 'rxjs/operators';
import {
  OneClickLoadPaymentsCompleteAction,
  OneClickPaymentsActionTypes,
  OneClickLoadPaymentsFromBuilderProductAction,
} from '../actions/one-click-payments.actions';
import { getOneClickState, OneClickState, State } from '../reducers';

@Injectable()
export class OneClickBuilderPaymentsEffects {
  paymentTermsFromBuilderProduct$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OneClickPaymentsActionTypes.LOAD_PAYMENTS_BUILDER_PRODUCT),
      filter((action: OneClickLoadPaymentsFromBuilderProductAction) => !!action.payload),
      switchMap((action) =>
        this.store.select(getOneClickState).pipe(
          take(1),
          map((state) => this.makePaymentsFromProductsRequestFromState(state, action.payload)),
          switchMap((request: CustomerPaymentTermsReq) => this.paymentTermsService.getCustomerPaymentTermsV3(request)),
          map((response: any) => new OneClickLoadPaymentsCompleteAction(response.paymentTerms, action.index)),
        ),
      ),
    ),
  );

  private makePaymentsFromProductsRequestFromState(state: OneClickState, product: IProduct): CustomerPaymentTermsReq {
    return {
      countryCode: state.shippingMethodsState.selected.countryCode,
      productLineId: getProductLineId(product),
      jobsiteId: state.jobsiteState.selected.jobsite.jobsiteId,
      customerId: state.jobsiteState.selected.customer.customerId,
      productId: getProductId(product),
      commercialChannelCode: OrderTypeCodesEnum.OneClickToBuy,
    } as CustomerPaymentTermsReq;
  }

  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private paymentTermsService: PaymentTermService,
  ) {}
}
